import { z } from 'zod';
import { vehicleGroupsSchema } from './vehicle-group.schema';

export const routeModifierSchema = z.object({
  name: z.string(),
  vehicleGroups: vehicleGroupsSchema,
  setId: z.number(),
  isDefault: z.boolean(),
});

export const routeModifiersSchema = z.array(routeModifierSchema);

export type RouteModifier = z.infer<typeof routeModifierSchema>;
